const SECONDS = 1000;
export const DEFAULT_TIMEOUT = 30 * SECONDS;
